import Link from '../ui/link'
import { cn } from '@telesoft/lib/web/cn'
import { navSchema } from '@telesoft/lib/web/constants/nav-schema'
import Image from 'next/image'
import React from 'react'

export default function Logo({ className, inverted = false, ...rest }: any) {
  return (
    <Link
      href={navSchema.logo.href}
      className={cn(
        'col-span-2 inline-flex justify-start items-center focus:outline-none',
        className,
      )}
      {...rest}
    >
      <Image
        src={inverted ? navSchema.logo.light : navSchema.logo.dark}
        alt={navSchema.logo.alt}
        height={navSchema.logo.height}
        width={navSchema.logo.width}
      />
    </Link>
  )
}
